module.exports = __webpack_public_path__ + "img/background_rutsche_w570.95276977.jpg";